import { supabase, BLOG_BUCKET } from './supabaseClient';
import blog1 from '../assets/blog1.jpeg';
import blog2 from '../assets/blog2.jpeg';
import blog3 from '../assets/blog3.jpeg';
import blog4 from '../assets/blog4.jpeg';
import blog5 from '../assets/blog5.jpeg';
import blog6 from '../assets/blog6.jpeg';


export const LINKEDIN_URL = 'https://www.linkedin.com/in/lms-marketing-services';

export const CATEGORIES = [
  { id: 'all', label: 'All Posts' },
  { id: 'investing', label: 'Investing' },
  { id: 'insurance', label: 'Insurance' },
  { id: 'planning', label: 'Financial Planning' },
  { id: 'loans', label: 'Loans' },
];

// Built-in starter articles. These always show, even before any DB posts exist.
export const DEFAULT_POSTS = [
  {
    id: 'default-1', tag: 'Mutual Funds', category: 'investing',
    title: 'Your Profession Gives Income. Mutual Funds Can Create Lifetime Income.',
    excerpt: 'Whatever profession you are in—businessman, doctor, engineer, teacher, employee, consultant, lawyer, or entrepreneur—your income may increase or decrease over time. Some years are excellent, while others may be challenging.',
    date: 'May 15, 2025', read: '5 min read',
     img: blog1,

     linkedinUrl: 'https://www.linkedin.com/posts/narendragm03_your-profession-gives-income-mutual-funds-activity-7471506873301536769-0I91?utm_source=share&utm_medium=member_ios&rcm=ACoAAD3aBRgBJXRf9y1moeGIvoDfPC17rjQM5tg', 
    // body: ``,
  },
  {
    id: 'default-2', tag: 'Risk Management', category: 'insurance',
    title: '5 Simple Money Rules for Wealth Creation',
    excerpt: 'Five simple money rules.',
    date: 'Apr 28, 2025', read: '4 min read',
    img: blog2,
    author: 'G.M. Narendra',
     linkedinUrl: 'https://www.linkedin.com/posts/narendragm03_five-simple-money-rules-1-dont-borrow-activity-7471486139581800448-dB3A?utm_source=share&utm_medium=member_ios&rcm=ACoAAD3aBRgBJXRf9y1moeGIvoDfPC17rjQM5tg', 
    // body: ``,
  },
  {
    id: 'default-3', tag: 'Stock Market', category: 'investing',
    title: 'He who understands it, earns it.',
    excerpt: 'An investor who starts early and stays invested through SIPs allows returns to generate further returns. Over time, wealth grows exponentially, not linearly.',
    date: 'Mar 20, 2025', read: '6 min read',
    img: blog3,
    author: 'G.M. Narendra',
     linkedinUrl: 'https://www.linkedin.com/posts/narendragm03_he-who-understands-it-earns-it-an-investor-activity-7471444581314625536-NaxE?utm_source=share&utm_medium=member_ios&rcm=ACoAAD3aBRgBJXRf9y1moeGIvoDfPC17rjQM5tg', 
    // body: ``,
  },
  {
    id: 'default-4', tag: 'Tax Planning', category: 'planning',
    title: 'Paise ka chakkar, babu bhaiya, paise ka chakkar.',
    excerpt: 'Everything revolves around money. Mutual Fund Perspective. In life, almost every important goal requires money:',
    date: 'Feb 10, 2025', read: '7 min read',
    img: blog4,
    author: 'G.M. Narendra',
     linkedinUrl: 'https://www.linkedin.com/posts/narendragm03_paise-ka-chakkar-babu-bhaiya-paise-ka-activity-7470731741591343106-pWm-?utm_source=share&utm_medium=member_ios&rcm=ACoAAD3aBRgBJXRf9y1moeGIvoDfPC17rjQM5tg', 
    // body: ``,
  },
  {
    id: 'default-5', tag: 'Home Loan', category: 'loans',
    title: 'Make Money While You Sleep with Mutual Funds',
    excerpt: 'If you don’t find a way to make money while you sleep, you will work until you die.',
    date: 'Jan 22, 2025', read: '5 min read',
    img: blog5,
    author: 'G.M. Narendra',
     linkedinUrl: 'https://www.linkedin.com/posts/narendragm03_if-you-dont-find-a-way-to-make-money-while-activity-7470805234848751617-hfKI?utm_source=share&utm_medium=member_ios&rcm=ACoAAD3aBRgBJXRf9y1moeGIvoDfPC17rjQM5tg', 
    // body: ``,
  },
  {
    id: 'default-6', tag: 'Retirement', category: 'planning',
    title: 'Mutual Fund Investing: Knowledge, Relationships, and Long-Term Success',
    excerpt: 'These powerful life concepts to mutual fund investing in a meaningful way:',
    date: 'Dec 18, 2024', read: '8 min read',
    img: blog6,
    author: 'G.M. Narendra',
     linkedinUrl: 'https://www.linkedin.com/posts/narendragm03_these-powerful-life-concepts-to-mutual-fund-activity-7470744777903210497-QRRs?utm_source=share&utm_medium=member_ios&rcm=ACoAAD3aBRgBJXRf9y1moeGIvoDfPC17rjQM5tg', 
    // body: ``,
  },
];

// Convert a Supabase row to the shape the UI expects.
function mapRow(row) {
  return {
    id: row.id,
    tag: row.tag || 'General',
    category: row.category || 'investing',
    title: row.title,
    excerpt: row.excerpt || (row.body ? row.body.slice(0, 160) + '\u2026' : ''),
    body: row.body || '',
    author: row.author || 'G.M. Narendra',
    read: row.read || '5 min read',
    img: row.img || 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&q=80',
    date: row.date || new Date(row.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    linkedinUrl: row.linkedinUrl || null, // Add this field
    isDb: true,
  };
}

// Fetch posts from Supabase, then append the built-in defaults.
export async function fetchAllPosts() {
  try {
    const { data, error } = await supabase
      .from('blogs')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) throw error;
    const dbPosts = (data || []).map(mapRow);
    return [...dbPosts, ...DEFAULT_POSTS];
  } catch (e) {
    console.error('Supabase fetch failed, showing default posts only:', e.message);
    return [...DEFAULT_POSTS];
  }
}

export async function fetchPostById(id) {
  const def = DEFAULT_POSTS.find(p => String(p.id) === String(id));
  if (def) return def;
  try {
    const { data, error } = await supabase.from('blogs').select('*').eq('id', id).single();
    if (error) throw error;
    return data ? mapRow(data) : null;
  } catch (e) {
    console.error('fetchPostById failed:', e.message);
    return null;
  }
}

// Upload a cover image to Supabase Storage, return its public URL.
export async function uploadCoverImage(file) {
  const ext = file.name.split('.').pop();
  const path = `covers/${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from(BLOG_BUCKET).upload(path, file, {
    cacheControl: '3600', upsert: false,
  });
  if (error) throw error;
  const { data } = supabase.storage.from(BLOG_BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function addPost(post) {
  const date = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const { data, error } = await supabase.from('blogs').insert([{ 
    ...post, 
    date,
    linkedinUrl: post.linkedinUrl || null
  }]).select().single();
  if (error) throw error;
  return mapRow(data);
}

export async function deletePost(id) {
  const { error } = await supabase.from('blogs').delete().eq('id', id);
  if (error) throw error;
}

// For the admin list: only DB posts (defaults can't be edited/deleted).
export async function fetchDbPosts() {
  const { data, error } = await supabase
    .from('blogs')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data || []).map(mapRow);
}
